import { useTranslation } from "react-i18next";
import { Card, CardTitle } from "../components/ui/card";
import { useTenant } from "./tenant-layout";

// Platzhalter der Übersicht. Hier entstehen später die Monitoring-Ansichten (A2).
export function OverviewPage() {
  const { t } = useTranslation();
  const tenant = useTenant();

  return (
    <div className="flex max-w-4xl flex-col gap-6">
      <h1 className="text-2xl text-ink">{t("overview.title")}</h1>
      <Card className="flex flex-col gap-2">
        <CardTitle>{t("overview.welcome", { name: tenant.name })}</CardTitle>
        <p className="text-sm text-ink-muted">
          {t("overview.yourRole")}: {t(`roles.${tenant.role}`)}
        </p>
      </Card>
      <Card>
        <p className="text-sm text-ink-muted">{t("overview.placeholder")}</p>
      </Card>
    </div>
  );
}
